import React from 'react';

export default function Chat(){
    return(
        <div className='commonbox chat'>
            <h1 className='boxheadings'>Group Chat Application<br></br>for the Disabled</h1>
            <img className='iphone' src= {require('./images/chat_mockup.png')}></img>
            <p className='app'>TCP Sockets & GoogleTTS API</p><br></br>
            <p className='sw'>Python, PyQt5 API </p>
        </div>
    );
}